















import Vue from 'vue';

export default Vue.extend({
  name: 'ResetButton',
  data: () => ({}),
  methods: {
    handleClick() {
      setTimeout(() => {
        this.$emit('click');
      }, 500);
    },
  },
});
